import { Link, useLocation } from "react-router";
import { useData } from "../../lib/context/DataContext";
import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import NumberStepper from "../../components/Inputs/NumberStepper";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import useStockProduit from "../../lib/hooks/useStockProduit";
import PaperDialog from "../../components/Dialog/PaperDialog";
import ErrorSubmitDataAlert from "../../components/Alert/ErrorSubmitDataAlert";
import LoadingDataAlert from "../../components/Alert/LoadingDataAlert";
import SuccessSubmitDataAlert from "../../components/Alert/SuccessSubmitDataAlert";
import useUserCommande from "../../lib/hooks/useUserCommande";
import CoverProductCard from "../../components/Cards/ProductCard/CoverProductCard";
import useUserData from "../../lib/hooks/useGraphUserData";

export default function AjouterCommande() {
	const idProduit = useLocation().pathname.split("/")[2];

	const { userCommande } = useUserCommande();

	const {
		produits,
		venteEnCours,

		commandeEnCours,
		fetchDataCommandes,
	} = useData();

	const { userData } = useUserData();

	const [status, setStatus] = React.useState(null);

	const [selectedProduit, setSelectedProduit] = React.useState(null);

	React.useEffect(() => {
		if (produits.loading === false && !selectedProduit && venteEnCours) {
			setSelectedProduit(
				produits.data.find((item) => item.rowKey === idProduit)
			);
			const stockSelectedProduit = {
				stock: JSON.parse(venteEnCours.produitsEnVente).find(
					(item) => item.rowKey === idProduit
				).quantite,
			};

			setSelectedProduit((prev) => ({
				...prev,
				...stockSelectedProduit,
			}));
		}
	}, [produits, selectedProduit, idProduit, venteEnCours]);

	const { stockProduit } = useStockProduit(
		selectedProduit && selectedProduit.rowKey,
		selectedProduit && selectedProduit.stock
	);

	const { setValue, handleSubmit, watch } = useForm();

	const [prevStockUser, setPrevStockUser] = React.useState(0);

	React.useEffect(() => {
		if (userCommande) {
			const quantiteCommander = userCommande
				? userCommande.find((item) => item.produit === idProduit)
					? userCommande.find((item) => item.produit === idProduit)
							.quantite
					: 0
				: 0;
			setValue("quantite", quantiteCommander);
			setPrevStockUser(quantiteCommander);
		}
	}, [userCommande, idProduit, setValue]);

	const onSubmit = async (data) => {
		setStatus("loading");

		const commandeFiltrer = userCommande.filter(
			(item) => item.produit !== idProduit
		);

		const updateCommande = [
			...commandeFiltrer,
			{
				produit: selectedProduit.rowKey,
				quantite: data.quantite,
			},
		];

		const sortingCommande = Object.values(
			updateCommande.reduce((acc, { produit, quantite }) => {
				if (!acc[produit]) {
					acc[produit] = { produit, quantite };
				} else {
					acc[produit].quantite += quantite;
				}
				return acc;
			}, {})
		);

		try {
			const res = await fetch("/api/updateCommande", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					partitionKey: commandeEnCours.partitionKey,
					rowKey: commandeEnCours.rowKey,
					[userData.id]: JSON.stringify(sortingCommande),
				}),
			});

			if (res.ok) {
				setStatus("success");
			} else {
				setStatus("error");
			}
		} catch (err) {
			setStatus("error");
		} finally {
			await fetchDataCommandes();
		}
	};

	return (
		<PaperDialog
			titre={"Ajouter à la commande"}
			onSubmit={handleSubmit(onSubmit)}
			actions={
				<>
					<Link to="..">
						<Button
							color="error"
							variant="contained"
						>
							{!status ? "Annuler" : "Fermer"}
						</Button>
					</Link>
					{!status && (
						<Button
							color="success"
							variant="contained"
							type="submit"
						>
							Valider
						</Button>
					)}
				</>
			}
		>
			{status === "error" && (
				<ErrorSubmitDataAlert>
					Une erreur est survenue lors de la prise de commande
				</ErrorSubmitDataAlert>
			)}
			{status === "loading" && <LoadingDataAlert />}
			{status === "success" && (
				<SuccessSubmitDataAlert>
					Le produit a été ajouté avec success à votre commande
				</SuccessSubmitDataAlert>
			)}
			{!status && (
				<>
					{!selectedProduit && !watch("quantite") ? (
						<Skeleton
							variant="rounded"
							height={20}
						/>
					) : (
						<Grid
							container
							spacing={3}
						>
							<Grid size={4}>
								<Box
									sx={{
										display: "block",
										position: "relative",
										width: "100%",
										height: "100%",
									}}
								>
									<CoverProductCard
										cover={selectedProduit.cover}
										id={selectedProduit.rowKey}
									/>
								</Box>
							</Grid>
							<Grid size={8}>
								<Stack spacing={1}>
									<Typography variant="h4">
										{selectedProduit.name}
										<Divider />
									</Typography>

									<Typography>
										<b>Catégorie : </b>
										{selectedProduit.categorie}
									</Typography>

									<Typography>
										<b>Stock restant : </b>
										{stockProduit +
											prevStockUser -
											watch("quantite")}{" "}
										{selectedProduit.unite}
									</Typography>

									<Stack
										component={Paper}
										variant="outlined"
										sx={{ p: 1 }}
										direction={{ xs: "column", sm: "row" }}
										alignItems={"center"}
										justifyContent="space-between"
									>
										<Typography
											variant="h6"
											fontWeight={800}
										>
											Mon Panier :
										</Typography>
										<NumberStepper
											initValue={watch("quantite")}
											min={0}
											max={stockProduit + prevStockUser}
											step={
												selectedProduit.unite === "Kg"
													? 0.1
													: 1
											}
											typeUnite={selectedProduit.unite} // "piece" ou "kg"
											onChange={(val) =>
												setValue("quantite", val)
											}
										/>
									</Stack>
								</Stack>
							</Grid>
						</Grid>
					)}
				</>
			)}
		</PaperDialog>
	);
}
